import Layout from '@/layout';
import { $vi18n } from '@/utils/i18n.js';
export default [
  {
    path: '/account',
    name: 'Account',
    redirect: '/account/settings',
    component: Layout,
    meta: {
      title: $vi18n('$i18n# 账号管理 #i18n$'),
      icon: 'icon-account',
    },
    children: [
      {
        path: 'settings',
        name: 'AccountSettings',
        component: () => import('@/views/account/overseas/setting.vue'),
        meta: {
          title: $vi18n('$i18n# 账号设置 #i18n$'),
        },
      },
      {
        path: 'editemail',
        component: () => import('@/views/account/overseas/editEmail.vue'),
        name: 'editEmail',
        meta: {
          title: $vi18n('$i18n# 修改邮箱 #i18n$'),
          activePath: 'settings'
        },
        hidden: true,
      },
      {
        path: 'equity',
        name: 'AccountEquity',
        component: () => import('@/views/account/overseas/right.vue'),
        meta: {
          title: $vi18n('$i18n# 账号权益 #i18n$'),
        },
      },
      // {
      //   path: 'modifyPhone',
      //   name: 'accModifyPhone',
      //   component: () => import('@/views/account/modifyPhone'),
      //   meta: {
      //     title: '$vi18n('$i18n# 修改手机 #i18n$')',
      //     activePath: 'settings',
      //   },
      //   hidden: true,
      //   children: [
      //     {
      //       path: 'newPhone',
      //       name: 'accNewPhone',
      //       component: () =>
      //         import('@/views/account/components/changePhone/newPhone'),
      //       meta: {
      //         title: '$vi18n('$i18n# 新号码 #i18n$')',
      //         activePath: 'settings',
      //       },
      //       hidden: true,
      //     },
      //     {
      //       path: 'successPhone',
      //       name: 'accSuccessPhone',
      //       component: () =>
      //         import('@/views/account/components/changePhone/successPhone'),
      //       meta: {
      //         title: '$vi18n('$i18n# 修改成功 #i18n$')',
      //         activePath: 'settings',
      //       },
      //       hidden: true,
      //     },
      //   ],
      // },
    ],
  },
];
